import { Subscription } from 'rxjs';

export abstract class BaseComponent {

    // store current user
    user: any = null;

    // define store all subscription
    protected subscription = new Subscription();

    protected currentUser<T>(key: string = 'userInfo'): T {
        if (!this.user) {
            const item = JSON.parse(localStorage.getItem(key));
            if (item != null) {
                this.user = item as T;
            }
        }
        return this.user;
    }

    // dispose
    protected dispose() {
        this.subscription.unsubscribe();
    }

}